<template src="./Notifications.html"> </template>

<script>

import { mapState, mapActions } from 'vuex';
import NotificationsList from './NotificationsList/NotificationsList.vue';
import NotificationsDashboard from './NotificationsDashboard/NotificationsDashboard.vue';

import SocialNotLoggedIn from '@/modules/Social/NotLoggedIn/NotLoggedIn.vue';

export default {
    name: 'Notifications',
    components: {
        NotificationsList,
        NotificationsDashboard,
        SocialNotLoggedIn
    },  
    data() {
        return {
            notificationsDashboard: {status: false, row: undefined},
        }
    },
    computed: {

        ...mapState({
            layers: state => state.map.mapLayers,
            ws: state => state.ws,

            dataAnalysisFullScreen: state => state.dataAnalysisFullScreen,

            user: state => state.social.user,
        }),

        getWs() {
            if (this.ws.ws.length > 0) {
                if (this.layers.length == 0)
                    this.setStationLayer();
                return this.ws.ws;
            }
            return []
        }

    },
    methods: {
        ...mapActions({
            addMapLayer: 'addMapLayer',

            getStations: 'getStations',
            setStations: 'setStations',

            setWsLayerStatus: 'setWsLayerStatus',

            setDataAnalysisFullScreen: 'setDataAnalysisFullScreen',
            setViewNotificationsManager: 'setViewNotificationsManager',
        }),

        expandDataAnalysis: function() {
            this.setDataAnalysisFullScreen(!this.dataAnalysisFullScreen);
        },

        onViewNotificationRow(row) {
            this.notificationsDashboard.status = !this.notificationsDashboard.status;
            this.notificationsDashboard.row = row;
        },

        setStationLayer() {
            let layers = [];
            this.ws.ws.forEach(ws => {
                layers.push({
                    type: 'marker',
                    id: ws._id,
                    data: ws,
                });
            });
            this.addMapLayer(layers);
        },

        getVWS() {
            this.getStations();
        },

        setNotificationStatus() {
            this.setDataAnalysisFullScreen(false);
            //this.setWsLayerStatus(false);
            this.setViewNotificationsManager(false);
            this.addMapLayer([]);
        }

    },
    mounted() {
        this.getVWS();
    },
    
}
</script>


<style lang="scss" src="./Notifications.scss"> </style>